<template>
  <div class="searchContent">
    <div class="breadcrumbs-wrap">
      <ul v-if="classList.length">
        <li>
          <span @click="$router.push({path:'/Home'})">首页</span>
          <i>></i>
        </li>
      </ul>
      <ul v-if="classList.length">
        <li v-for="(t,i) in classList" :key="i">
          <span @click="toSearch(t)">{{ t.FName }}</span>
          <i v-if="i !== classList.length - 1">></i>
        </li>
      </ul>
      <span v-if="!classList.length">
        <span class="allResult" @click="searchAll">全部结果</span>
        <i>></i>
        <span style="font-weight:600;">"{{ this.$route.query.search.trim() || this.$route.query.markName }}"</span>
      </span>
    </div>
    <div class="top">
      <!-- <span class="shop">{{ constName }}</span>
      <span class="searchNum">
        （共
        <span style="color: #ec2631">{{ shopList.shop.length }}</span>
        件相关商品）
      </span> -->
      <!-- <span v-if="advanceList.length > 0" class="select-right">></span> -->
      <div
        v-for="(item, index) in advanceList"
        :key="index"
        class="text-select"
      >
        <span>{{ item.name }}</span>
        <span class="select-text">{{ item.text }}</span>
        <i @click="removeCurrentSelect(index, item)">x</i>
      </div>
      <span
        v-if="advanceList.length > 0"
        class="clear-all"
        @click="removeAllSelect"
      >清空筛选</span>
    </div>
    <!-- <span class="breadcrumbs-wrap">
      1
    </span> -->
    <advancedFilter
      v-if="isShowFilter"
      ref="advancedFilter"
      :filter-box.sync="filerlist"
      :const-name="constName"
      @getAdvance="getAdvanceSearch"
    />
    <MySizer
      ref="sortF"
      :total="shopList.shop.length"
      :is-total="1"
      :val="3"
      :isprice="1"
      :is-format="1"
      :slot-item="slotItem"
      @onScreen="onScreen"
      @onActive="onActive"
      @onPrice="onPrice"
      @changeFormat="changeFormat"
    >
      <span slot="1">综合</span>
      <span slot="2">销量</span>
      <span slot="3">价格</span>
    </MySizer>
    <div v-if="shopList.shop.length > 0" id="shopList" v-loading="searchLoading" class="shopList">
      <ul v-if="format">
        <li
          v-for="(item, index) in paction"
          :key="index"
          @click="onTapToDetail(item)"
        >
          <div class="img">
            <template v-if="item.img">
              <img width="212px" height="212px" :src="item.img" alt>
            </template>
            <template v-else>
              <img
                style="object-fit: contain"
                width="212px"
                height="212px"
                src="@/assets/images/stockImg.jpg"
                alt
              >
            </template>
            <div v-if="item.fOperationMode == 0" class="self-support">
              自营
            </div>
          </div>
          <div class="firsText">
            <div v-if="FPriceShow" class="price">
              <template v-if="item.IsDirectoryPool">
                <span style="font-weight:bold;">
                  {{ _stockPrice(item.fStockPrice,item.FTPriceDecimal) }}
                  <span v-if="item.StockFMeasurement">{{
                    "/" + item.StockFMeasurement
                  }}</span>
                </span>
                <del
                  style="margin-left: 15px; color: #333; font-size: 12px"
                >￥{{  _stockPrice(item.fPrice,item.FTPriceDecimal) }}
                </del>
              </template>
              <div v-else class="isDirectoryPool">
                不在目录池
              </div>
            </div>
            <div v-else class="noShowPrice">
              <span>￥</span>价格不可见
            </div>
          </div>
          <div class="shopName" v-html="htmlValue(item.name)" />
          <div class="codeBox">
            订货编码：
            <span class="copyCode" @click.stop="copyCode(item.FShortCode,0)">
              <span class="codeInfo">{{ item.FShortCode | filterCode }}</span>
              <!-- <el-tooltip class="item" effect="dark" :content="item.FShortCode" placement="top-start">
            </el-tooltip> -->
              <i class="el-icon-document-copy" />
            </span>
          </div>
          <div class="codeBox">
            <template v-if="item.FDemandStcokCode">
              需方编码：
              <span class="copyCode" @click.stop="copyCode(item.FDemandStcokCode,1)">
                <el-tooltip class="item" effect="dark" :content="item.FDemandStcokCode" placement="top-start">
                  <span class="codeInfo">{{ item.FDemandStcokCode | filterCode }}</span>
                </el-tooltip>
                <i class="el-icon-document-copy" />
              </span>
            </template>
          </div>
          <!-- <div v-if="item.shopType" class="shopType">
            <span
              v-for="(val, id) in item.shopType"
              :key="id"
              style="padding-right: 9px"
            >{{ val }}</span>
          </div> -->
          <div class="codeBox delivery">
            发货日：
            <el-tooltip class="item" effect="dark" :content="item.fDeliveryInfo" placement="top-start">
              <el-tag
                v-if="item.fDeliveryInfo"
                type="warning"
                effect="plain"
              >
                {{ item.fDeliveryInfo | delivery }}
              </el-tag>
            </el-tooltip>
            <span class="deliveryAddress">
              <i class="el-icon-location-outline" />
              {{ assderFilt(item.webareaFLevelName) }}
            </span>
          </div>
          <!-- <div style="margin-top: 8px; font-size: 12px;height:38px;">
            <span style="line-height:16px;">
              发货日：<span v-if="item.fDeliveryInfo" class="deliverData">{{ item.fDeliveryInfo }}</span>
            </span>
            <span style="float:right;">
              <svg-icon style="margin-right: 5px" icon-class="address" />{{
                assderFilt(item.webareaFLevelName)
              }}
            </span>
          </div> -->
          <div class="goods-item-btn">
            <template v-if="item.IsDirectoryPool || !name">
              <div class="ability-btn" @click.stop="collection(item)">
                <span class="iconEnter"><svg-icon style="margin-right: 5px;" :icon-class="item.fCollectioned ? 'collection2' : 'collection'" /></span>
                <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="collection1" /></span>
                <span :class="item.fCollectioned ? '' : 'writeText'">{{ item.fCollectioned ? '已收藏' : '收藏' }}</span>
              </div>
              <div class="ability-btn" @click.stop="addCart(item)">
                <span class="iconEnter"><svg-icon style="margin-right: 5px;" :icon-class="item.isAddCart ? 'cart' : 'cart2'" /></span>
                <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="cart1" /></span>
                <span :class="item.isAddCart ? '' : 'writeText'">{{ item.isAddCart ? '已加入购物车' : '加入购物车' }}</span>
              </div>
            </template>
            <el-popover
              v-else
              style="flex:1;"
              placement="top-start"
              trigger="hover"
              width="160"
            >
              <div slot="reference" style="width:100%;" class="ability-btn">
                <span class="iconEnter"><svg-icon style="margin-right: 5px;" icon-class="newPhone1" /></span>
                <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="newPhone2" /></span>
                联系我们
              </div>
              <div>
                <div>
                  <svg-icon style="margin-right: 5px;" icon-class="red-user" />
                  {{ $store.state.user | userName }}
                </div>
                <div>
                  <span class="iconEnter"><svg-icon style="margin-right: 5px;" icon-class="newPhone" /></span>
                  {{ $store.state.user | userPhone }}
                </div>
              </div>
            </el-popover>
          </div>
        </li>
      </ul>
      <el-table
        v-else
        ref="multipleTable"
        :data="paction"
        tooltip-effect="dark"
        style="width: 100%"
        header-row-class-name="table-header"
        :header-cell-class-name="cellClsss"
        :row-class-name="rowClass"
        class="showTable"
      >
        <!-- <el-table-column
          width="110"
        >
          <template slot="header">
            <el-checkbox v-model="allCheck" @change="checkAllStock" />
            <span style="color:#999999;margin-left: 10px;">全选</span>
          </template>
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.check" @change="checkStock" />
          </template>
        </el-table-column> -->
        <el-table-column
          prop="name"
          label="图例"
          width="120"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 90px; height: 90px"
              :src="scope.row.StockFCover || require('@/assets/images/stockImg.jpg')"
              :preview-src-list="[scope.row.StockFCover]"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品信息"
          width="420"
        >
          <template slot-scope="scope">
            <!-- <el-image
              style="width: 60px; height: 60px"
              :src="scope.row.StockFCover || require('@/assets/images/stockImg.jpg')"
              :preview-src-list="[scope.row.StockFCover]"
            /> -->
            <div class="stock-info" @click="onTapToDetail(scope.row)">
              <div v-if="scope.row.fOperationMode == 0" class="self-support">
                自营
              </div>
              {{ scope.row.StockFName }}
            </div>
            <div class="codeBox">
              订货编码：
              <span class="copyCode" @click.stop="copyCode(scope.row.FShortCode,0)">
                <span class="codeInfo">{{ scope.row.FShortCode }}</span>
                <i class="el-icon-document-copy" />
              </span>
            </div>
            <div class="codeBox">
              <template v-if="scope.row.FDemandStcokCode">
                需方编码：
                <span class="copyCode" @click.stop="copyCode(scope.row.FDemandStcokCode,1)">
                  <span class="codeInfo">{{ scope.row.FDemandStcokCode }}</span>
                  <!-- <el-tooltip class="item" effect="dark" :content="scope.row.FDemandStcokCode" placement="top-start">
                  </el-tooltip> -->
                  <i class="el-icon-document-copy" />
                </span>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="发货地"
        >
          <template slot-scope="scope">
            <div class="shipment-place">
              <i class="el-icon-location-outline" />
              {{ assderFilt(scope.row.webareaFLevelName) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="发货时间"
        >
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.fDeliveryInfo" class="item" effect="dark" :content="scope.row.fDeliveryInfo" placement="top">
              <div class="shipment-time">
                {{ scope.row.fDeliveryInfo }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="专享价"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.IsDirectoryPool" style="color:#EC212D;font-size:16px;">
              <span style="font-size:12px;">￥</span>
              <span style="font-weight:600;" v-html="stockPrice(scope.row.fStockPrice,20)" />
              <span v-if="scope.row.StockFMeasurement" style="color:#333333;">/{{ scope.row.StockFMeasurement }}</span>
            </span>
            <div v-else class="isDirectoryPool">
              不在目录池
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          width="200"
        >
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :disabled="!scope.row.IsDirectoryPool" :min="0" @change="numberChange(scope.row)" />
          </template>
          <template slot="header">
            <div :style="selectNum ? 'padding-right:15px' : ''" class="add-shopCar" @click="addShopCar">
              <svg-icon
                icon-class="right-shop"
              />
              加入购物车
              <span v-show="selectNum" class="fizz">{{ selectNum }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right;margin:20px;"
        background
        layout="prev, pager, next,jumper"
        :current-page.sync="Collect.pageNo"
        :page-size.sync="Collect.pageSize"
        :total="Collect.total"
        @current-change="CollectSear(false)"
      />
      <div v-if="!format" class="footerAmount">
        已选<span style="font-weight:bold;color:#333;">{{ selectAmount }}</span>件商品
        <div class="rightMoney">
          总金额：<span style="margin-right:32px;">￥<span v-html="stockPrice(selectMoney,18)" /></span>
          <div class="addCart" @click="addShopCar">
            <svg-icon
              icon-class="right-shop"
            />
            加入购物车
          </div>
        </div>
      </div>
    </div>
    <div v-else v-loading="searchLoading" class="shopNone">
      <img src="@/assets/images/no-data.png" alt>
      <p>{{ tipText }}</p>
    </div>
  </div>
</template>
<script>
import service from '@/utils/request.js'
import MySizer from '@/components/sizer/index.vue'
import MyList from '@/components/MyList.vue'
import advancedFilter from '@/components/advancedFilter/index.vue'
import quest from '../api/searchPage'
import { mapGetters } from 'vuex'
export default {
  components: {
    MySizer,
    MyList,
    advancedFilter
  },
  filters: {
    filterCode(val) {
      if (val && val.length > 9) {
        return val.slice(0, 9)
      } else {
        return val
      }
    },
    delivery(val) {
      if (val && val.length > 6) {
        return val.slice(0, 6)
      } else {
        return val
      }
    },
    userPhone(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return rightstr
      } else {
        return ''
      }
    },
    userName(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return leftstr
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      selectMoney: 0,
      selectAmount: 0,
      selectNum: 0,
      allCheck: false,
      format: 1,
      tipText: '未能找到符合条件的商品，请重新搜索。',
      search: '电钻',
      Collect: {
        pageNo: 1,
        pageSize: 30,
        total: 0
      },
      hisPrice: {},
      slotItem: [{}, { hasArrow: true, sales: true }, { hasArrow: true }],
      hisSort: {}, // 记录排序
      paction: [], // 分页后的商品
      shopList: {
        num: 777,
        shop: [
          // {
          //   img: "",
          //   price: "50.00 / 米",
          //   addr: "河南周口",
          //   name: "东成Z1F-FF-26电锤 混凝土打孔 钻墙冲击钻电钻",
          //   shopType: ["交流电源", "轻型"],
          //   storeName:
          //     "周口市鑫宏达五金机电有限公司周口市鑫宏达五金机电有限公司"
          // }
        ],
        mallstore: []
      },
      advanceList: [], // 筛选的结果展示
      filerlist: [
        {
          name: '品牌:',
          allCheck: false,
          propId: 0, // 品牌固定标识id为0
          Temporary: [], // 多选暂存
          allCheckList: [],
          items: [
            // { value: '1', text: '博世(BOSCH)', active: false },
          ]
        },
        {
          name: '标准类别:',
          allCheck: false,
          checkNone: true, // 非多选
          propId: 0.1, // 标准类别id为0.1
          allCheckList: [],
          Temporary: [], // 多选暂存
          items: [
            // { value: "allAge", text: "电动工具", active: false },
          ]
        }
      ],
      constName: '', // 根据路由固定商品搜索名
      loading: null,
      searchLoading: false,
      classList: [],
      FPriceShow: 0,
      isShowFilter: false
    }
  },
  watch: {
    '$route.query': {
      handler(val) {
        this.constName =val.search? val.search.trim() || '':"";
        this.$refs.advancedFilter && this.$refs.advancedFilter.removeAllSelect(1)
        this.constName = val.search
        const params = {
          'queryStockName': val.search? val.search.trim() || '':"",
          'FTreeCode': val.classification || '',
          'markIDs': val.markID || ''
        }
        if (!val.classification) {
          this.classList = []
        }
        console.log('监听')
        this.searchLink(params)
      },
      deep: true
    },
    'shopList.shop': {
      handler(val) {
        if (this.shopList.reset) { this.shopList.reset = false } else {
          this.CollectSear(true)
        }

        this.$set(this.Collect, 'total', this.shopList.shop.length)
      },
      deep: true
    },
    filerlist: {
      deep: true,
      handler(val) {
        let num = 0
        val.forEach(t => {
          num += t.items.length
        })
        this.isShowFilter = !!num
      }
    },
    paction: {
      deep: true,
      handler() {
        if (!this.format) {
          this.checkStock()
        }
      }
    }
  },
  computed: {
    ...mapGetters(['name'])
  },
  mounted() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    this.constName = this.$route.query.search !== undefined ? this.$route.query.search.trim() : ''
    if (this.constName !== '') {
      this.$parent.$parent.$parent.$refs.headerSearch.search = this.$route.query.search
    }
    const params = {
      'queryStockName': this.constName || '',
      'FTreeCode': this.$route.query.classification || '',
      'markIDs': this.$route.query.markID || ''
    }
    if (this.$route.query.classification) {
      this.getClassList(this.$route.query.classification)
    }
    this.searchLink(params)
    console.log('mtd')
  },
  methods: {
    _stockPrice(val,FTPriceDecimal) {
      let price = val||0;
      console.log(val)
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      return price
    },
    stockPrice(val, size,FTPriceDecimal) {
      let price = val||0;
      console.log(val)
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      if(price.indexOf(".")>-1){
        const arr = price.split('.')
        return `<span style='font-size:${size}px;'>${arr[0]}</span>.${arr[1]}`
  
      }else{
        return `<span style='font-size:${size}px;'>${price}</span>`
  
      }
    },
    copyCode(val, n) {
      const str = n ? '需方编码' : '订货编码'
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.setAttribute('create', 1)
      input.select()
      document.execCommand('Copy')
      this.$notify({
        message: `${str}已成功复制`,
        type: 'success',
        position: 'bottom-left',
        duration: 1000
      })
      var list = document.getElementsByTagName('input')
      var inputList = Array.prototype.slice.call(list)
      inputList.forEach((item) => {
        if (item.getAttribute('create'))document.body.removeChild(item)
      })
    },
    numberChange(row) {
      row.check = true
      this.checkStock()
    },
    addShopCar() {
    //   if (!this.selectNum) return this.$message.warning('没有选择加入!')
      const jsonobj = {
        shoppingCartList: []
      }
      this.paction.map(t => {
        if (t.quantity) {
          jsonobj.shoppingCartList.push({
            'fstockName': t.StockFName,
            'fmallstoreStockId': t.mallstorestockFID,
            'fQuanty': t.quantity
          })
        }
      })
      const data = new URLSearchParams()
      data.append('jsonobj', JSON.stringify(jsonobj))
      service({
        url: '/mall/stockmanage/mallstorestock/addShoppingCart',
        method: 'post',
        data
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.$parent.$parent.$parent.$refs.headerSearch.getComput()
            this.$parent.$parent.$parent.$refs.rightNav.getComput()
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    checkStock() {
      let a = 0
      let n = 0
      let m = 0
      this.paction.map(t => {
        if (t.quantity) {
          n++
          a += t.quantity
          m += (t.fStockPrice * t.quantity)
        }
      })
      this.allCheck = n == this.paction.length
      this.selectNum = n
      this.selectAmount = a
      this.selectMoney = m
    },
    checkAllStock(val) {
      this.allCheck = val
      this.selectNum = val ? this.paction.length : 0
      this.paction.map(t => { t.check = val })
    },
    rowClass({ row, rowIndex }) {
      if (row.check) {
        return 'select_row'
      }
    },
    cellClsss({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 5) {
        if (this.selectNum) {
          return 'haveSelect'
        } else {
          return 'noSelect'
        }
      }
    },
    changeFormat(val) {
      const y = window.scrollY
      this.format = val
      this.$nextTick(() => {
        window.scrollTo(0, y)
      })
    },
    searchAll() {
      this.$parent.$parent.$parent.$refs.headerSearch.reSearch()
    },
    toSearch(item) {
      const Time = new Date().getTime()
      const routeUrl = this.$router.resolve({
        path: '/search/searchPage',
        redirect: '',
        query: {
          classification: item.FTreeCode,
          Time
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    getClassList(currentTreeCode) {
      service({
        url: '/mall/mallmanage/index/getTreeCodeClass',
        method: 'post',
        params: {
          currentTreeCode
        }
      })
        .then(res => {
          this.classList = res.data.FStdClassList || []
        })
    },
    addCart(item) {
    //   if (!item.FStockQuanty) return this.$message.warning('该商品无库存！')
      const jsonobj = {
        'shoppingCartList': [{
          'fstockName': item.StockFName,
          'fmallstoreStockId': item.mallstorestockFID,
          'fQuanty': 1
        }]
      }
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(jsonobj))
      service({
        url: '/mall/stockmanage/mallstorestock/addShoppingCart',
        method: 'post',
        data: params
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.$set(item, 'isAddCart', 1)
            this.$parent.$parent.$parent.$refs.headerSearch.getComput()
            this.$parent.$parent.$parent.$refs.rightNav.getComput()
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    collection(item) {
      const operationType = item.fCollectioned ? 3 : 1
      const url = `/mall/stockmanage/mallstorestock/collectStock/${item.mallstorestockFID}/0/${operationType}`
      service({
        url,
        method: 'get'
      })
        .then(res => {
          if (res.result) {
            item.fCollectioned = item.fCollectioned ? 0 : 1
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    assderFilt(item) {
      const asderr = item.split('\\')
      let index = asderr.find((items) => {
        if (items) {
          return String(items).search('市') > -1
        } else {
          return false
        }
      })
      if (!index) {
        index = asderr[asderr.length - 1]
      }
      return index
    },
    picrFilter(item) {
      const arr = [
        item.FNoAPPrice,
        item.FOnMAPPrice,
        item.FTwMAPPrice,
        item.FThMAPPrice,
        item.FFoMAPPrice,
        item.FFiMAPPrice
      ]
      const showPrice = arr[Number(item.fDayLimit)]
      const showSpliPrice = showPrice.toString().split('.')

      const str = !isNaN(Number(showPrice))
        ? Number(showPrice).toFixed(3)
        : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    FixedTo(num) {
      const str = !isNaN(Number(num)) ? Number(num).toFixed(3) : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    CollectSear(clear) {
      this.selectNum = 0
      this.allCheck = false
      // 分页
      if (clear) {
        this.$set(this.Collect, 'pageNo', 1)
        this.$set(this.Collect, 'pageSize', 30)
      }
      const size = this.Collect.pageNo * this.Collect.pageSize
      const pageIds = this.shopList.shop.filter((item, index) => {
        if (
          index >=
            this.Collect.pageNo * this.Collect.pageSize -
              this.Collect.pageSize &&
          index < size
        ) {
          return true
        }
      })
      const pagemallIds = this.shopList.mallstore.filter((item, index) => {
        if (
          index >=
            this.Collect.pageNo * this.Collect.pageSize -
              this.Collect.pageSize &&
          index < size
        ) {
          return true
        }
      })
      this.getformation(pageIds, null, pagemallIds, null)
    },
    // 组件进入、路由参数变更调用 搜索
    searchLink(sear, n) {
      let FSearchType
      this.$parent.$parent.$parent.$refs.headerSearch && (FSearchType = Number(!this.$parent.$parent.$parent.$refs.headerSearch.isShoping))
      console.log(this.$parent.$parent.$parent.$refs.headerSearch,Number(!this.$parent.$parent.$parent.$refs.headerSearch.isShoping))
      sear['FSearchType'] = FSearchType
      this.allCheck = false
      this.selectNum = 0
      this.loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.3)',
        target: document.querySelector('.submit-test-dialog'),
        customClass: 'searchLoading'
      })
      this.tipText = ''
      //   sear.queryStockName = sear.queryStockName.replaceAll(' ', '%')
      quest.AllIndexStock(sear).then((res) => {
        if (res.result) {
          this.loading.close()
          // 数据为0重置数据
          if (res.data.length == 0) {
            this.shopList = {
              num: 0,
              shop: [],
              mallstore: []
            }
            this.filerlist = [
              {
                name: '品牌:',
                allCheck: false,
                propId: 0, // 品牌固定标识id为0
                Temporary: [], // 多选暂存
                allCheckList: [],
                items: [
                  // { value: '1', text: '博世(BOSCH)', active: false },
                ]
              },
              {
                name: '标准类别:',
                allCheck: false,
                checkNone: true, // 非多选
                propId: 0.1, // 标准类别id为0.1
                allCheckList: [],
                Temporary: [], // 多选暂存
                items: [
                  // { value: "allAge", text: "电动工具", active: false },
                ]
              }
            ]
            // this.tipText = '未能找到符合条件的商品，请重新搜索。'
            return
          }
          const formationids = []
          const mallstorestockFIDs = []
          const markids = []
          const stdstockclassids = []

          res.data.forEach((item) => {
            // 商品ids
            if (item.providerstockFID) formationids.push(item.providerstockFID)
            if (item.mallstorestockFID)mallstorestockFIDs.push(item.mallstorestockFID)
            //  品牌ids

            if (item.markFID) markids.push(item.markFID)
            //  标准类别ids
            if (item.stdstockclassFID) {
              stdstockclassids.push(item.stdstockclassFID)
            }
          })

          // 分出第一页
          const formationPage = formationids.filter(
            (item, index) => index < this.Collect.pageSize
          )
          const mallstorestockPage = mallstorestockFIDs.filter(
            (item, index) => index < this.Collect.pageSize
          )
          this.getformation(formationPage, formationids, mallstorestockPage, mallstorestockFIDs, () => {
            this.constName = sear.queryStockName
          })
          this.PropWith(formationids)
          this.getMake(markids, true)
          this.getStockClass(stdstockclassids)
        } else {
          this.constName = sear.queryStockName
          this.loading.close()
        }
      })
        .catch((e) => {
          this.loading.close()
        })
    },
    // 根据搜索返回的ids调用获取商品接口；
    getformation(list, formationLength, mallstorestockPage, mallstorestockFIDs, callfn) {
      this.tipText = ''
      const ids = list.join(',')
      const mids = mallstorestockPage.join(',')
      quest.StockInformation(ids, this.hisSort, mids).then((res) => {
        if (res.data) {
          this.$set(
            this,
            'paction',
            res.data.map((item) => {
            //   item.FShortCode = item.FShortCode ? item.FShortCode.slice(0, 9) : ''
              return {
                quantity: 0,
                check: false,
                mallstorestockFID: item.mallstorestockFID,
                img: item.StockFCover || '',
                price: item.providerstockFPrice || 0,
                addr: item.webareaFName || '',
                name: item.StockFName || '',
                shopType: [], // 暂时不存在次字段
                storeName: item.providerunitFProviderUnitName || '',
                ...item
              }
            })
          )
        } else {
          this.$set(this, 'paction', [])
          if (this.hisPrice.FMaxPrice || this.hisPrice.FMinPrice) {
            this.tipText = '未能找到符合条件的商品，请重新输入价格。'
          } else {
            this.tipText = '未能找到符合条件的商品，请重新搜索。'
          }
        //   console.log(list, formationLength, mallstorestockPage, mallstorestockFIDs, callfn)
        }
        if (formationLength) {
          this.shopList.reset = true
          this.$set(this.shopList, 'shop', formationLength)
        }
        if (mallstorestockFIDs) {
          this.$set(this.shopList, 'mallstore', mallstorestockFIDs)
        }
        callfn && callfn()
      })
        .catch(() => {
          if (this.hisPrice.FMaxPrice || this.hisPrice.FMinPrice) {
            this.tipText = '未能找到符合条件的商品，请重新输入价格。'
          } else {
            this.tipText = '未能找到符合条件的商品，请重新搜索。'
          }
        })
    },
    // 根据搜索返回的品牌id查询对应品牌名；
    getMake(list, ones) {
      const ids = list.join(',')
      //   quest.MakeRequest(ids)
      const data = new URLSearchParams()
      data.append('jsonStr', JSON.stringify({ markFIDs: ids }))
      service({
        url: '/mall/mallmanage/index/queryAllIndexStockMark',
        method: 'post',
        data
      })
        .then((res) => {
          if (res.result) {
            this.$set(
              this.filerlist[0],
              'items',
              res.data.map((item) => {
                return {
                  id: item.markFID,
                  value: item.markFID,
                  text: item.markFName || '',
                  active: false
                }
              })
            )
            if (ones) {
              this.$refs.advancedFilter.makeCopy()
            }
            this.$refs.advancedFilter.nowEnIndex = -1
          } else {
          }
        })
        .catch(() => {
        })
    },
    // / 需方首页商品搜索根据标准类别IDs获取检索标准类别
    getStockClass(list) {
      const ids = list.join(',')
      quest.StockStdStockClass(ids).then((res) => {
        if (res.result) {
          const jsonArr = res.data.map((item) => {
            return {
              ...item,
              value: item.stdstockclassFID || '',
              text: item.stdstockclassFName || '',
              active: false
            }
          })
          this.$set(this.filerlist[1], 'items', jsonArr)
        }
      })
    },
    // 根据搜索返回的商品id查询对应规格参数；
    PropWith(list) {
      if (!this.constName) return
      const ids = list.join(',')
      const data = new URLSearchParams()
      data.append('jsonStr', JSON.stringify({ providerStockFIDs: ids }))
      service({
        url: '/mall/mallmanage/index/queryAllIndexStockPropWithValue',
        method: 'post',
        data
      })
      //   quest.PropWithRequest(ids)
        .then((res) => {
          if (res.result) {
            const obj = {}

            res.data.forEach((item) => {
              const prop = {
                value: item.stdstockpropvalueFID || '',
                text: item.stdstockpropvalueFValue || '',
                active: false
              }
              if (obj[item.stdstockpropFName]) {
                const idsOf = String(obj[item.stdstockpropFName].ids).split(',')
                if (idsOf.indexOf(String(item.stdstockpropFID)) < 0) {
                  obj[item.stdstockpropFName].ids += `,${item.stdstockpropFID}`
                }
                const next = obj[item.stdstockpropFName].find(
                  (nexts) =>
                    nexts.stdstockpropvalueFValue == item.stdstockpropvalueFValue
                )
                if (next) {
                  const idsValOf = String(next.value).split(',')

                  if (idsValOf.indexOf(String(item.stdstockpropvalueFID)) < 0) {
                    next.value += `,${item.stdstockpropvalueFID}`
                  }
                } else {
                  obj[item.stdstockpropFName].push({ ...item, ...prop })
                }
              } else {
                obj[item.stdstockpropFName] = [{ ...item, ...prop }]
                obj[item.stdstockpropFName].ids = item.stdstockpropFID
              }
            })
            this.filerlist.splice(2, this.filerlist.length - 1)
            Object.keys(obj).forEach((item) => {
              this.filerlist.push({
                propId: obj[item].ids || '',
                name: item,
                allCheck: false,
                allCheckList: [],
                Temporary: [], // 多选暂存
                items: obj[item]
              })
            })
          } else {
          }
        })
        .catch(() => {

        })
    },
    getAdvanceSearch(arr) {
      this.allCheck = false
      this.selectNum = 0
      this.advanceList = arr
      this.initShop(arr)
    },
    // 商品检索条件
    initShop(Of, sort, price) {
      if (!sort) sort = this.hisSort
      if (!price) price = this.hisPrice
      const data = {}
      Of.map((item) => {
        if (item.index < 1) {
          switch (item.index) {
            // 品牌
            case 0:
              if (item.list) {
                data.markIDs = item.list
                  .map((item) => {
                    return item.id || ''
                  })
                  .join(',')
              } else {
                data.markIDs = item.id || ''
              }
              break
            // 标准类别
            case 0.1:
              if (item.list) {
                data.FTreeCode = item.list
                  .map((item) => {
                    return item.stdstockclassFTreeCode || ''
                  })
                  .join(',')
              } else {
                data.FTreeCode = item.stdstockclassFTreeCode || ''
              }
              break
          }
        } else {
          // 参数规格
          if (!data.ValueGroupList) data.ValueGroupList = []

          if (item.list) {
            let listprop = item.list.map((itemas) => {
              return itemas.value
            })
            listprop = listprop.join(',').split(',')
            data.ValueGroupList.push({
              id: listprop
            })
          } else {
            data.ValueGroupList.push({
              id: String(item.value).split(',')
            })
          }
        }
      })
      // {"queryStockName":"String 检索商品名称","FTreeCode":"String 标准类别FTreeCode","markIDs":"String 品牌Id,隔开","ValueGroupList":[{"id":[1,2,3]},{"id":[1,2,3]}]},"FMinPrice":"int 最低价格","FMaxPrice":"int 最高价格","FSortType":"int 0=综合 1=销量 2=价格 3=上新","FSortVal":"String 升降序 -1=无排序 0=升序 1=降序"}
      const FTreeCode = this.$route.query.classification || ''
      let FSearchType
      this.$parent.$parent.$parent.$refs.headerSearch && (FSearchType = Number(!this.$parent.$parent.$parent.$refs.headerSearch.isShoping))
      quest
        .StockInformationFilter({
          queryStockName: this.constName,
          FTreeCode,
          FSearchType,
          ...data,
          ...sort,
          ...price
        })
        .then((res) => {
          if (res.result) {
            if (res.data.length) {
              const formationids = []
              const markids = []
              const stdstockclassids = []
              const mallstorestockFIDs = []
              res.data.forEach((item) => {
                // 商品ids
                if (item.providerstockFID) {
                  formationids.push(item.providerstockFID)
                }
                //  品牌ids
                if (item.markFID) markids.push(item.markFID)
                if (item.mallstorestockFID)mallstorestockFIDs.push(item.mallstorestockFID)
                //  标准类别ids
                if (item.stdstockclassFID) {
                  stdstockclassids.push(item.stdstockclassFID)
                }
              })

              // 分出第一页
              const formationPage = formationids.filter(
                (item, index) => index < this.Collect.pageSize
              )
              const mallstorestockPage = mallstorestockFIDs.filter(
                (item, index) => index < this.Collect.pageSize
              )
              this.getformation(formationPage, formationids, mallstorestockPage, mallstorestockFIDs)
              this.PropWith(formationids)
              this.getMake(markids, true)
              this.getStockClass(stdstockclassids)
            } else {
              this.filerlist.splice(2, this.filerlist.length - 1)
              this.$set(this.shopList, 'shop', [])
            }
          }
        })
    },
    htmlValue(val) {
      const key = this.search
      if (key.length > 0) {
        return val.replace(
          new RegExp(key, 'g'),
          "<span style='color: #EC212D;'>" + key + '</span>'
        )
      }
      return val
    },
    /**
     * 删除筛选项
     */
    removeCurrentSelect(index, item) {
      this.$refs.advancedFilter.removeCurrentSelect(index, item)
    },
    // 清空全部筛选按钮
    removeAllSelect() {
      this.$refs.advancedFilter.removeAllSelect()
    },
    // 选择并获取数据
    onScreen(e) {
      this.onActive(e.type, e.buttonType)
    },
    // 选择最高价和最低价
    onPrice(e) {
      if (e.maxPrice === '' && e.minPrice === '') {
        this.shopList.shop = []
      }
      const data = {
        FMinPrice: e.minPrice || '',
        FMaxPrice: e.maxPrice || ''
      }
      this.hisPrice = data
      this.initShop(this.advanceList || [], null, data)
    },
    onActive(val, type) {
      const sortD = type == 'top' ? 0 : type == 'bottom' ? 1 : -1
      const sort = {}
      switch (val) {
        // 销量
        case 2:
          sort.FSortType = 1
          sort.FSortVal = sortD
          break
        // 价格
        case 3:
          sort.FSortType = 2
          sort.FSortVal = sortD
          break
        // 综合
        default:
          sort.FSortType = 0
      }
      this.hisSort = sort
      this.initShop(this.advanceList || [], sort)
    },
    onTapToDetail(val) {
      const isShoping = Number(this.$parent.$parent.$parent.$refs.headerSearch.isShoping)
      const url = `${location.protocol}//${location.host}/#/store/details?mallstorestockFId=${val.mallstorestockFID}&shopid=${val.FMallStoreID}&isShoping=${isShoping}`
      open(url)
      // this.$router.push({
      //   path: '/store/details',
      //   query: {
      //     mallstorestockFId: val.mallstorestockFID,
      //     shopid: val.FMallStoreID
      //   }
      // })
    }
  }
}
</script>
<style lang="scss">
.searchLoading  {
    .el-icon-loading {
        font-size:55px;
        color: #fff;
    }
    .el-loading-text {
        font-size: 16px;
        color: #fff;
    }
}
#shopList {
    .showTable {
        .el-table__body-wrapper .cell {
            height: 90px;
            display: inherit;
        }
        .el-input-number {
           span {
                width: 38px;
           }
        }
    }
    .footerAmount {
        height: 60px;
        line-height: 60px;
        background: #FFFFFF;
        padding-left: 28px;
        margin-bottom: 40px;
        font-size: 14px;
        color: #999999;
        .rightMoney {
            float: right;
            span {
                font-size: 12px;
                font-weight: bold;
                color: #EC212D;
            }
            .addCart {
                caret-color: transparent;
                cursor: pointer;
                display: inline-block;
                width: 180px;
                height: 60px;
                line-height: 60px;
                font-size: 16px;
                font-weight: bold;
                color: #fff;
                background: #EC212D;
                text-align: center;
                .svg-icon {
                    margin-right: 8px;
                }
            }
        }
    }
    .el-pagination {
        .number {
            border: 1px solid #dcdfe6;
            background: #fff;
        }
        .active {
            border: 1px solid #EC212D;
            background: #EC212D;
        }
    }
    .delivery {
        word-wrap: break-word;
        word-break: break-all;
        position: relative;
        // margin-top: 3px;
        margin-bottom: 10px;
        line-height: 20px;
        .el-tag {
            background: #F5783C;
            color: #fff;
            height: 20px;
            line-height: 20px;
        }
        .deliverData {
            display: inline-block;
            font-size: 12px;
            color: #fff;
            background: #F5783C;
            padding: 0 5px;
            font-family: Microsoft YaHei;
            line-height: 16px;
            border-radius: 2px;
        }
        .deliveryAddress {
            position: absolute;
            right: 0;
        }
    }
    li {
        caret-color: rgba(0, 0, 0, 0);
    }
    .codeBox {
        display: flex;
        font-size: 12px;
        color: #666;
        min-height: 21px;
        line-height: 21px;
        .copyCode {
            display: flex;
            line-height: 21px;
            cursor: pointer;
        }
        i {
            line-height: 21px;
            margin-left: 6px;
        }
        .codeInfo {
            display: inline-block;
            max-width: 134px;
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
        }
    }
    .isDirectoryPool {
        min-width: 90px;
        height: 24px;
        line-height: 24px;
        padding-left: 10px;
        background: #fbd2d5;
        font-size: 14px;
        color: #EC212D;
        font-weight: bold;
    }
    .cell {
        display: flex;
    }
    .haveSelect,.noSelect {
        padding: 0;
        .cell {
            position: relative;
            height: 48px;
            padding: 0;
        }
    }
    .haveSelect {
        background: #fff !important;
    }
    .noSelect {
        background: #fff !important;
    }
}
.shopList {
    .el-table__body-wrapper {
        min-height: 450px;
        caret-color: rgba(0,0,0,0);
        .el-input__inner {
            caret-color: #000;
        }
    }
    .select_row {
        background-color: #f5f7fa;
        .el-table__cell {
            border-bottom-color: #fff;
        }
    }
    // .el-table__row:hover {
    //     .el-table__cell {
    //         border-bottom-color: #fff;
    //     }
    // }
    .table-header {
        .el-table__cell {
            background: #fff !important;
        }
        .cell {
            color:#666666;
            font-weight: bold;
            font-size: 14px;
        }
    }

    .add-shopCar {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        cursor: pointer;
        min-width: 128px;
        height: 32px;
        background: #EC212D;
        border-radius: 6px;
        line-height: 32px;
        text-align: center;
        color: #fff;
         .fizz{
        position: absolute;
        right:2px;
        top: 1px;
        width: 26px;
        height: 15px;
        line-height: 15px;
        background: #fff;
        color: #EC212D;
        border-radius: 8px 8px 8px 0px;
        opacity: 0.88;
        font-size: 12px;
        text-align: center;
        transform: translateX(0%) translateY(0%);
      }
    }
    .shipment-time {
        font-size: 12px;
        text-align: center;
        min-width: 64px;
        min-height: 32px;
        line-height: 32px;
        background: #F5783C;
        color: #fff;
        border-radius: 4px;
    }
    .shipment-place {
        text-align: center;
        font-size: 12px;
        min-width: 64px;
        height: 32px;
        line-height: 32px;
        background: rgba(245,120,60,0.14);
        border-radius: 4px;
        border: 1px solid #F5783C;
        color: #F5783C;
    }
    .stock-info {
        flex: 1;
        cursor: pointer;
        font-size: 16px;
        line-height: 22px;
        height: 44px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        .self-support {
            display: inline-block;
            width: 35px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            border-radius: 3px;
            background: #ec2631;
            color:#fff;
            font-size: 12px;
        }
    }
    .stock-info:hover {
        color: #ec2631;
    }
    .cell {
        display: flex;
    }
}
</style>
<style lang="scss" scoped>
.searchContent {
  width: 100%;
  .breadcrumbs-wrap {
        display: flex;
        font-size: 14px;
        height: 44px;
        line-height: 44px;
        color: #666;
        i {
            font-size: 14px;
            margin: 0 10px;
            }
        ul {
            cursor: pointer;
            display: flex;

            span:hover {
                color: #ec2631;
            }
        }
        .allResult:hover {
            cursor: pointer;
            color: #ec2631;
        }
  }
  .top {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
     margin-bottom: 10px;
    .shop {
      font-size: 16px;
      color: #ec2631;
      padding-right: 17px;
    }
    .searchNum {
      font-size: 12px;
      color: #999;
    }
    .select-text {
      color: #ec212d;
      margin: 0 5px;
    }
    .clear-all {
      width: 62px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 2px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      cursor: pointer;
    }
  }
  .select-right {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    margin-right: 10px;
  }
  .text-select {
    height: 22px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 2px;
    margin-right: 10px;
    padding: 4px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .shopList {
    width: 100%;
    ul {
        min-height: 450px;
      display: flex;
      flex-wrap: wrap;
      margin: auto;
      // justify-content: space-between;
      // justify-content: flex-start;
    //   li:nth-child(4n - 1) {
    //     margin-right: 0 !important;
    //   }
      li {
          cursor: pointer;
        width: 236px;
        height: 429px;
        background: #ffffff;
        border: 1px solid transparent;
        padding: 11px;
        margin-top: 10px;
        margin-right: 10px;
        font-size: 12px;
        position: relative;
        &:hover {
          border: 1px solid #e9e9e9;
          box-shadow: 0 0 2px 2px #f8f8f8;
          &::before {
            // content: "详情";
            width: 233px;
            height: 46px;
            color: #fff;
            font-size: 14px;
            text-align: center;
            line-height: 46px;
            position: absolute;
            // top: 126px;
            left: 0;
            bottom: 137px;
            background: rgba(236, 33, 45, 0.8);
            // background: linear-gradient(
            //   0deg,
            //   #ec212d 0%,
            //   rgba(236, 33, 45, 0) 100%
            // );
          }
        }
        &:nth-child(5n) {
          margin-right: 0;
        }
        .self-support {
            position: absolute;
            top: 11px;
            right: 11px;
            width: 35px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            border-radius: 3px;
            background: #ec2631;
            color:#fff;
        }
        .goods-item-btn {
            display: flex;
            justify-content: space-between;
            .ability-btn {
            caret-color: rgba(0,0,0,0);
            cursor: pointer;
            display: inline-block;
            width: 102px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border: 1px solid #E8E8E8;
            border-radius: 4px;
            font-size: 12px;
            color: #EC212D;
            .writeText {
                color: #333;
            }
            .iconHover {
                display: none;
            }
        }
        .ability-btn:hover {
            background: #EC212D;
            border-color: #EC212D;
            color: #fff;
            .writeText {
                color: #fff;
            }
            .iconEnter {
                display: none;
            }
            .iconHover {
                display: inline-block;
            }
        }
        }
        .firsText {
          height: 24px;
          line-height: 24px;
          margin-top: 12px;
          .noShowPrice {
              position: relative;
              top: -5px;
              height: 26px;
              line-height: 26px;
              padding-left: 10px;
              font-size: 14px;
              color: #ec2631;
              font-weight: 600;
            //   background: #fbd3d5;
              span {
                  font-size: 12px;
              }
          }
        }
        .price {
            width: 100%;
          font-size: 16px;
          color: #ec2631;
          float: left;
        }
        .addr {
          font-size: 14px;
          color: #000;
          float: right;
        }
        .deliverData {
            font-size: 12px;
            color: #fff;
            background: #ff8e50;
            padding: 0 5px;
            font-family: Microsoft YaHei;
            line-height: 16px;
            border-radius: 5px;
        }
        .shopName {
          height: 42px;
          line-height: 21px;
          font-size: 14px;
          font-weight: bold;
          color: #333;
          margin-top: 10px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; //此处为行数，可以改为任意数字
        }
        .shopType {
          color: #999;
          margin-top: 12px;
        }
        .storeName {
          font-size: 14px;
          color: #000;
          margin-top: 8px;
          overflow: hidden; /*溢出隐藏*/
          white-space: nowrap; /*规定文本不进行换行*/
          text-overflow: ellipsis; /*当对象内文本溢出时显示省略标记（...）*/
        }
      }
    }
  }
  .shopNone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 150px 0;
    img {
      width: 184px;
      height: 184px;
    }
    p {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>
